var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"grades-percentages-component"},[_c('grade-percent',{staticClass:"margin-2 padding-1 border-blue shadow width-8 height-8-5"}),_c('attendance-percent',{staticClass:"margin-2 padding-1 border-blue shadow width-8 height-8-5"}),_c('on-time-percent',{staticClass:"margin-2 padding-1 border-blue shadow width-8 height-8-5"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }